import styled from 'styled-components';
import { rem } from 'polished';
import { white } from 'Styles/colors';
import { fontTitle } from 'Styles/fonts';

export const Puck = styled.div`
  position: relative;
  display: flex;
  height: 24px;
  width: 24px;
  justify-content: center;
  align-items: center;
`;

export const Hexagon = styled.span`
  font-family: var(--glyph-font), sans-serif;
  font-size: ${rem(42)};
  line-height: 24px;
  color: ${({ $fill }) => $fill};
  position: absolute;
  left: -1px;
  font-variant: normal;

  &:before {
    content: 'A';
  }
`;

export const Count = styled.span`
  ${fontTitle(12)};
  color: ${white};
  position: absolute;
`;
